import { gql } from '@apollo/client';

const ALPHAPLAN_INTEGRATION_FRAGMENT = gql`
    fragment AlphaplanIntegrationFields on AlphaplanIntegrationType {
        id
        createdAt
        updatedAt
        name
        baseUrl
        hasApiKey
        hasPassword
        hasCaBundle
        username
        proxy
        supplierFilter
        supplierNumberField
        purchaseOrderBelegType
        openPoFilter
        ocAbNumberField
        ocWriteMode
        ocWriteOnConvertedPo
        ocPositionMemoField
        ocHeaderMemoField
        ocToleranceBlock
        readMode
        attachSourceDocuments
        capabilities
        integrationParameters
        masterDataUpdateActive
        masterDataUpdatedAt
        masterDataUpdateError
        fetchProgress
        orderConfirmationChannels {
            id
            name
        }
        invoiceChannels {
            id
            name
        }
    }
`;

export const GET_ALPHAPLAN_INTEGRATIONS = gql`
    query AlphaplanIntegrations {
        alphaplanIntegrations {
            ...AlphaplanIntegrationFields
        }
    }
    ${ALPHAPLAN_INTEGRATION_FRAGMENT}
`;

export const GET_ALPHAPLAN_INTEGRATION_PARAMETER_DEFINITIONS = gql`
    query AlphaplanIntegrationParameterDefinitions {
        alphaplanIntegrationParameterDefinitions {
            key
            type
            default
            description
        }
    }
`;

export const CREATE_ALPHAPLAN_INTEGRATION = gql`
    mutation CreateAlphaplanIntegration(
        $name: String!
        $baseUrl: String!
        $apiKey: String!
        $username: String
        $password: String
        $proxy: String
        $caBundle: String
        $supplierFilter: String
        $supplierNumberField: String
        $purchaseOrderBelegType: Int
        $openPoFilter: String
        $ocAbNumberField: String
        $ocWriteMode: String
        $ocWriteOnConvertedPo: Boolean
        $ocPositionMemoField: String
        $ocHeaderMemoField: String
        $ocToleranceBlock: Boolean
        $readMode: String
        $attachSourceDocuments: Boolean
        $integrationParameters: JSONString
        $orderConfirmationChannels: [UUID]
        $invoiceChannels: [UUID]
    ) {
        createAlphaplanIntegration(
            name: $name
            baseUrl: $baseUrl
            apiKey: $apiKey
            username: $username
            password: $password
            proxy: $proxy
            caBundle: $caBundle
            supplierFilter: $supplierFilter
            supplierNumberField: $supplierNumberField
            purchaseOrderBelegType: $purchaseOrderBelegType
            openPoFilter: $openPoFilter
            ocAbNumberField: $ocAbNumberField
            ocWriteMode: $ocWriteMode
            ocWriteOnConvertedPo: $ocWriteOnConvertedPo
            ocPositionMemoField: $ocPositionMemoField
            ocHeaderMemoField: $ocHeaderMemoField
            ocToleranceBlock: $ocToleranceBlock
            readMode: $readMode
            attachSourceDocuments: $attachSourceDocuments
            integrationParameters: $integrationParameters
            orderConfirmationChannels: $orderConfirmationChannels
            invoiceChannels: $invoiceChannels
        ) {
            integration {
                ...AlphaplanIntegrationFields
            }
        }
    }
    ${ALPHAPLAN_INTEGRATION_FRAGMENT}
`;

export const UPDATE_ALPHAPLAN_INTEGRATION = gql`
    mutation UpdateAlphaplanIntegration(
        $id: UUID!
        $name: String
        $baseUrl: String
        $apiKey: String
        $username: String
        $password: String
        $proxy: String
        $caBundle: String
        $supplierFilter: String
        $supplierNumberField: String
        $purchaseOrderBelegType: Int
        $openPoFilter: String
        $ocAbNumberField: String
        $ocWriteMode: String
        $ocWriteOnConvertedPo: Boolean
        $ocPositionMemoField: String
        $ocHeaderMemoField: String
        $ocToleranceBlock: Boolean
        $readMode: String
        $attachSourceDocuments: Boolean
        $integrationParameters: JSONString
        $orderConfirmationChannels: [UUID]
        $invoiceChannels: [UUID]
    ) {
        updateAlphaplanIntegration(
            id: $id
            name: $name
            baseUrl: $baseUrl
            apiKey: $apiKey
            username: $username
            password: $password
            proxy: $proxy
            caBundle: $caBundle
            supplierFilter: $supplierFilter
            supplierNumberField: $supplierNumberField
            purchaseOrderBelegType: $purchaseOrderBelegType
            openPoFilter: $openPoFilter
            ocAbNumberField: $ocAbNumberField
            ocWriteMode: $ocWriteMode
            ocWriteOnConvertedPo: $ocWriteOnConvertedPo
            ocPositionMemoField: $ocPositionMemoField
            ocHeaderMemoField: $ocHeaderMemoField
            ocToleranceBlock: $ocToleranceBlock
            readMode: $readMode
            attachSourceDocuments: $attachSourceDocuments
            integrationParameters: $integrationParameters
            orderConfirmationChannels: $orderConfirmationChannels
            invoiceChannels: $invoiceChannels
        ) {
            integration {
                ...AlphaplanIntegrationFields
            }
        }
    }
    ${ALPHAPLAN_INTEGRATION_FRAGMENT}
`;

export const DELETE_ALPHAPLAN_INTEGRATION = gql`
    mutation DeleteAlphaplanIntegration($id: UUID!) {
        deleteAlphaplanIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_ALPHAPLAN_INTEGRATION_MASTER_DATA_UPDATE = gql`
    mutation TriggerAlphaplanIntegrationMasterDataUpdate($id: UUID!, $recordTypes: [String]) {
        triggerAlphaplanIntegrationMasterDataUpdate(id: $id, recordTypes: $recordTypes) {
            started
            message
        }
    }
`;

export const TEST_ALPHAPLAN_INTEGRATION_CONNECTION = gql`
    mutation TestAlphaplanIntegrationConnection($id: UUID!) {
        testAlphaplanIntegrationConnection(id: $id) {
            ok
            warnings
            errors
            capabilities
            probes
            version
            licence
            fullname
            batchMax
        }
    }
`;
